(function () {
  var announce = document.querySelector("[data-announce]");
  if (announce) {
    var slides = announce.querySelectorAll("[data-announce-slide]");
    var index = 0;
    var close = announce.querySelector("[data-announce-close]");
    if (sessionStorage.getItem("florev-announce-hidden") === "1") {
      announce.hidden = true;
    }
    if (close) {
      close.addEventListener("click", function () {
        sessionStorage.setItem("florev-announce-hidden", "1");
        announce.hidden = true;
      });
    }
    if (slides.length > 1 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.setInterval(function () {
        slides[index].classList.remove("is-active");
        index = (index + 1) % slides.length;
        slides[index].classList.add("is-active");
      }, 4200);
    }
  }

  var hero = document.querySelector("[data-hero]");
  if (hero) {
    var heroSlides = hero.querySelectorAll("[data-hero-slide]");
    var dots = hero.querySelectorAll("[data-hero-dot]");
    var heroIndex = 0;
    var paused = false;
    function show(next) {
      heroSlides[heroIndex].classList.remove("is-active");
      if (dots[heroIndex]) dots[heroIndex].classList.remove("is-active");
      heroIndex = (next + heroSlides.length) % heroSlides.length;
      heroSlides[heroIndex].classList.add("is-active");
      if (dots[heroIndex]) dots[heroIndex].classList.add("is-active");
      hero.classList.remove("hero--mint", "hero--sand", "hero--forest");
      var tone = heroSlides[heroIndex].className.match(/hero--(mint|sand|forest)/);
      if (tone) hero.classList.add(tone[0]);
    }
    hero.addEventListener("mouseenter", function () { paused = true; });
    hero.addEventListener("mouseleave", function () { paused = false; });
    hero.querySelector("[data-hero-prev]")?.addEventListener("click", function () { show(heroIndex - 1); });
    hero.querySelector("[data-hero-next]")?.addEventListener("click", function () { show(heroIndex + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () { show(Number(dot.getAttribute("data-hero-dot"))); });
    });
    if (heroSlides.length > 1 && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      window.setInterval(function () {
        if (!paused) show(heroIndex + 1);
      }, 6500);
    }
  }

  var drawer = document.querySelector("[data-cart-drawer]");
  var countNodes = document.querySelectorAll("[data-cart-count]");
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: currency });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove("drawer-open");
  }

  function setCount(count) {
    countNodes.forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
  }

  function renderCart(cart) {
    if (!drawer) return;
    var items = drawer.querySelector("[data-cart-items]");
    var subtotal = drawer.querySelector("[data-cart-subtotal]");
    var empty = drawer.querySelector("[data-cart-empty]");
    var footer = drawer.querySelector("[data-cart-footer]");
    var ship = drawer.querySelector("[data-cart-ship]");
    var bar = drawer.querySelector("[data-cart-progress]");
    setCount(cart.item_count);
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (items) items.replaceChildren();
    var hasItems = cart.items && cart.items.length > 0;
    if (empty) empty.hidden = hasItems;
    if (footer) footer.hidden = !hasItems;
    if (hasItems && items) {
      cart.items.forEach(function (item) {
        var row = document.createElement("li");
        row.className = "cart-row";
        var img = document.createElement("img");
        img.alt = "";
        img.width = 80;
        img.height = 96;
        if (item.image) img.src = item.image;
        var body = document.createElement("div");
        var title = document.createElement("a");
        title.href = item.url;
        title.textContent = item.product_title;
        title.className = "cart-row__title";
        var price = document.createElement("p");
        price.className = "cart-row__price";
        price.textContent = money(item.final_line_price);
        var controls = document.createElement("div");
        controls.className = "qty";
        var minus = document.createElement("button");
        minus.type = "button";
        minus.textContent = "−";
        minus.setAttribute("aria-label", "Decrease " + item.product_title);
        minus.addEventListener("click", function () { changeLine(item.key, item.quantity - 1); });
        var qty = document.createElement("span");
        qty.textContent = String(item.quantity);
        var plus = document.createElement("button");
        plus.type = "button";
        plus.textContent = "+";
        plus.setAttribute("aria-label", "Increase " + item.product_title);
        plus.addEventListener("click", function () { changeLine(item.key, item.quantity + 1); });
        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "text-button";
        remove.textContent = "Remove";
        remove.addEventListener("click", function () { changeLine(item.key, 0); });
        controls.append(minus, qty, plus);
        body.append(title, price, controls, remove);
        if (item.image) row.append(img);
        row.append(body);
        items.append(row);
      });
    }
    var threshold = Number(drawer.getAttribute("data-threshold") || 0);
    if (ship && bar && threshold > 0) {
      var remaining = threshold - cart.total_price;
      var progress = cart.total_price <= 0 ? 0 : Math.min(100, (cart.total_price / threshold) * 100);
      bar.style.width = progress + "%";
      ship.textContent = remaining > 0
        ? money(remaining) + " away from free shipping"
        : "You have free shipping";
    }
  }

  function refreshCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) { return res.json(); }).then(renderCart);
  }

  document.querySelectorAll("[data-cart-open]").forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      refreshCart().then(openDrawer);
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (button) {
    button.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  document.querySelectorAll(".js-product-form").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var button = form.querySelector("[type='submit']");
      var original = button ? button.textContent : "";
      if (button) button.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: Number(data.get("id")),
          quantity: Number(data.get("quantity") || 1)
        })
      }).then(function (res) {
        if (!res.ok) throw new Error("Could not add to bag");
        return refreshCart();
      }).then(function () {
        if (button) {
          button.textContent = "Added";
          window.setTimeout(function () {
            button.textContent = original;
            button.disabled = false;
          }, 1200);
        }
        openDrawer();
      }).catch(function () {
        if (button) button.disabled = false;
        form.submit();
      });
    });
  });

  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!main) return;
        main.src = thumb.getAttribute("data-src");
        main.alt = thumb.getAttribute("data-alt") || "";
        gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (other) {
          other.classList.toggle("is-active", other === thumb);
        });
      });
    });
  });

  var discount = document.querySelector("[data-discount-apply]");
  if (discount) {
    discount.addEventListener("click", function () {
      var input = document.querySelector("[data-discount-input]");
      var code = input && input.value.trim();
      if (!code) return;
      window.location = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
    });
  }

  document.querySelectorAll("[data-video-play]").forEach(function (button) {
    var root = button.closest("[data-video-banner], .hero__slide, .vcard") || button.parentElement;
    var video = root && root.querySelector("video");
    if (!video) return;
    function sync() {
      button.classList.toggle("is-playing", !video.paused);
      button.setAttribute("aria-label", video.paused ? "Play video" : "Pause video");
    }
    button.addEventListener("click", function () {
      if (video.paused) video.play();
      else video.pause();
      sync();
    });
    video.addEventListener("play", sync);
    video.addEventListener("pause", sync);
    sync();
  });

  document.querySelectorAll("[data-hover-video]").forEach(function (card) {
    var video = card.querySelector("video");
    if (!video) return;
    card.addEventListener("mouseenter", function () { video.play(); });
    card.addEventListener("mouseleave", function () { video.pause(); });
    card.addEventListener("focusin", function () { video.play(); });
    card.addEventListener("focusout", function () { video.pause(); });
  });

  document.querySelectorAll("[data-plant-show]").forEach(function (show) {
    var track = show.querySelector(".plant-show__track");
    if (!track) return;
    var step = function () { return Math.max(240, track.clientWidth * 0.7); };
    var prev = show.querySelector("[data-plant-prev]");
    var next = show.querySelector("[data-plant-next]");
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  });

  var search = document.querySelector("[data-search]");
  document.querySelectorAll("[data-search-open]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (!search) return;
      search.hidden = false;
      var input = search.querySelector("input[name='q']");
      if (input) input.focus();
    });
  });
  document.querySelectorAll("[data-search-close]").forEach(function (button) {
    button.addEventListener("click", function () {
      if (search) search.hidden = true;
    });
  });
})();
